import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { EditDomainNameSchema } from "../../../../utils/mainTabs/admin/organizationSettings/setUpDomainSchema";
import { isDomainNameExistsActionHandler } from "../../../../store/actions/actionHandlers/adminActionHandler/organizationActionHandler";
import { useSelector } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../../../components/Common/Button/Button";
import { FormattedMessage, injectIntl } from "react-intl";
import Input from "../../../../components/Common/Input/Input";
import classes from "./EditDomainNameForm.module.scss";
import { updateDomainNameActionHandler } from "../../../../store/actions/actionHandlers/adminActionHandler/organizationActionHandler";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";

const EditDomainNameForm = ({
  editDomainNameId,
  editDomainName,
  handleSearchQuery,
  handleEditModal,
  intl,
}) => {
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [loader, setLoader] = useState(false)
  const [isEditDomainNameExists, setIsEditDomainNameExists] = useState(null);
  const methods = useForm({
    defaultValues: { EditDomainName: "" },
    resolver: yupResolver(EditDomainNameSchema),
    mode: "onChange",
  });
  const {
    handleSubmit,
    formState: { isValid: editDomainIsValid, errors, isDirty },
    setFocus,
    setValue,
  } = methods;
  useEffect(() => {
    setValue("EditDomainName", editDomainName);
    setFocus("EditDomainName");
  }, [setFocus, setValue, editDomainName]);
  const handleEditDomainNameExists = (e) => {
    let val = e.target.value.trim() !== "" && e.target.value;
    if (val && editDomainIsValid && isDirty) {
      dispatch(isDomainNameExistsActionHandler(val)).then((response) => {
        if (response && response.status === 200) {
          if (response.data) {
            setIsEditDomainNameExists(true);
          } else {
            setIsEditDomainNameExists(false);
          }
        }
      });
    } else {
      setIsEditDomainNameExists(false);
    }
  };
  const onEditSubmit = (data) => {
    setLoader(true)
    dispatch(
      updateDomainNameActionHandler(
        data.EditDomainName,
        editDomainNameId,
        handleSearchQuery
      )
    ).then((isUpdated) => {
      if (isUpdated) {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            `Domain Name ${data.EditDomainName} edit successfully`
          )
        );
        setLoader(false)
        handleSearchQuery();
        handleEditModal(0);
      }
    });
  };
  return (
    <FormProvider {...methods}>
      <form
        className={classes.editDomainName__editModal}
        onSubmit={handleSubmit(onEditSubmit)}
      >
        <div className={classes.editDomainName__editModal__editField}>
          <Input
            name={"EditDomainName"}
            direction="row"
            placeholder={intl.formatMessage({
              id: `DOMAIN_NAME`,
            })}
            height="5"
            width="30"
            gap="0"
            onChange={(e) => handleEditDomainNameExists(e)}
            // loading={editTrainingNameExistsLoader}
            // error={editTrainingTypeErrors?.["EditTrainingType"]?.message}
          />
          {errors?.EditDomainName?.message ? (
            <div
              className={classes.editDomainName__editModal__editField__error}
            >
              {errors?.EditDomainName?.message}
            </div>
          ) : (
            isEditDomainNameExists && (
              <div
                className={classes.editDomainName__editModal__editField__error}
              >
                <FormattedMessage id="TRAINING_NAME_EXIST" />
              </div>
            )
          )}
        </div>
        <div className={classes.editDomainName__editModal__footer}>
          <Button
            label={<FormattedMessage id="USERGRP_ACTIONBUTN_TEXT" />}
            // backgroundColor={addTrainingTypeLoader ? undefined : colors.theme}
            borderRadius={"0.7"}
            // color={addTrainingTypeLoader ? undefined : "#fff"}
            disabled={!editDomainIsValid || isEditDomainNameExists}
            width={"14.5"}
            height={"4.9"}
            type="submit"
            loading={loader}
          />
          <div
            className={classes.editDomainName__editModal__footer__button2}
            onClick={() => handleEditModal(0)}
          >
            <FormattedMessage id="USERGRP_CANCELBTN_TEXT" />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default React.memo(injectIntl(EditDomainNameForm));
